export enum VisImpFontSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum VisImpLetterSpacing {
  Normal = 'normal',
  Increased = 'medium',
  Big = 'large',
}

export enum VisImpSwitchColor {
  Normal = 'normal',
  Invert = 'invert',
  Contrast = 'contrast',
}

export enum VisImpFontType {
  SansSerif = 'sans-serif',
  Serif = 'serif',
}

export enum VisImpStatus {
  Disabled = 0,
  Active = 1,
}

export enum VisImpSwitchImage {
  False = 0,
  True = 1,
}

export interface VisuallyImpairedSettings extends Record<string, any> {
  visuallyImpaired?: VisImpStatus;
  fontSize: VisImpFontSize;
  switchColor: VisImpSwitchColor;
  switchImages: VisImpSwitchImage;
  letterSpacing: VisImpLetterSpacing;
  fontStyle: VisImpFontType;
}
